import { useAuthStore } from "@src/stores/auth-store";
import { getSocket } from "@src/utils/websocket";
import { useEffect } from "react";
import {useQueryClient} from 'react-query';
import {votingKeys} from '@src/queries/voting.queires';

export function useShowNotificationPopupOnNewVote(setModal: (it: boolean) => void, setVoteId: (id: string) => void) {
    const token = useAuthStore().token;
    const queryClient = useQueryClient();

    useEffect(() => {
        const socket = getSocket(token as string);
        socket.on("newNotification", (notification) => {
            console.log("Received notification:", notification);
            if(notification.newVote === true) {
                const voteId = notification.voteDashboardRefresh.voteId;
                queryClient.invalidateQueries({queryKey: ['votingList']});
                queryClient.invalidateQueries({
                    queryKey: votingKeys.votingListDetails(voteId),
                });
                setModal(true);
                setVoteId(voteId);
            }
        });
 
        return () => {
            socket.off("newNotification");
        };
  }, [queryClient, setModal, setVoteId, token]);
}
